import mod from "-!./PdfViewer.js?vue&type=script&lang=js&"; export default mod; export * from "-!./PdfViewer.js?vue&type=script&lang=js&"